export default "__VITE_ASSET__DjcL131v__"